import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { sanitizeHtml } from '../../util/htmlSanitizer';
import css from './SafeHtml.module.css';

const SafeHtml = props => {
  const { html, className, rootClassName } = props;
  const sanitized = useMemo(() => sanitizeHtml(html), [html]);

  if (!sanitized) {
    return null;
  }

  const classes = classNames(rootClassName || css.htmlDescription, className);

  return <div className={classes} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

SafeHtml.defaultProps = {
  className: null,
  rootClassName: null,
  html: null,
};

SafeHtml.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  html: PropTypes.string,
};

export default SafeHtml;
